( function( $, document, window ) {
	'use strict';

	$( function() {
		const activeClass = 'is-active';
		const $tab = $( '.js-tab-nav-item' );

		$tab.on( 'click', function( e ) {
			e.preventDefault();

			// If this is not already active
			if ( ! $( this ).hasClass( activeClass ) ) {
				const $current = $( this ).closest( '.js-tabs-block' );
				const contentID = $( this ).attr( 'href' );
				const $newContent = $current.find( contentID );
				const $activeContent = $current.find( '.js-tab-content.is-active' );
				const $activeNavItem = $current.find( '.js-tab-nav-item.is-active' );

				// Remove active class from active link
				$activeNavItem.removeClass( activeClass );

				// Add active class to clicked link
				$( this ).addClass( activeClass );

				// Hide active content, show new content
				$activeContent.removeClass( activeClass );
				$newContent.addClass( activeClass );

				// Recalculate waypoints positions
				Waypoint.refreshAll();
			}
		} );
	} );
} )( jQuery, document, window );
